<template>
  <div>
    <!-- 商品管理添加商品 -->
    <el-dialog :close-on-click-modal="false"
      title="档口授权"
      :visible.sync="gateAuthorVisible"
      :before-close="gateAuthorHandleClose"
      width="53.2%"
      center
    >
      <el-divider></el-divider>
      <div class="tranStfer">
        <!-- <div style="text-align: center">
          <el-transfer
            style="text-align: left; display: inline-block"
            v-model="value4"
            filterable
            :left-default-checked="[2, 3]"
            :right-default-checked="[1]"
            :titles="['选择', '选择']"
            :button-texts="['删除', '添加']"
            :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      }"
            @change="handleChange"
            :data="data"
          >
            <span slot-scope="{ option }">{{ option.key }} - {{ option.label }}</span>
          </el-transfer>
        </div>-->
        <div class="contentQp">
          <div class="qpLeft">
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="qpCenter">
            <div class="qpCenterBtn">
              <div>
                <div>
                  <button>选择</button>
                  <div>
                    <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                      class="allCheck"
                    >全部选择</el-checkbox>
                  </div>
                </div>
                <div>
                  <button>取消</button>
                  <button>全部取消</button>
                </div>
              </div>
            </div>
          </div>
          <div class="qpRight">
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="itemBtnS">
          <el-button>清空</el-button>
          <el-button class="btnL">确认授权</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="addRestaurantVisible"
      :before-close="addRestaurantHandleClose"
      width="50.1%"
      center
    >
      <el-divider></el-divider>
      <div class="addRestaurantForm">
        <el-form ref="form" :model="form" label-width="100px">
          <div class="itemOne">
            <el-form-item label="名称:">
              <span class="xingA">*</span>
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="营业日期:">
              <span class="xingB">*</span>
              <div class="itemTwo">
                <div style="margin-right: 15px;">
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="checkAll"
                    @change="handleCheckAllChangeData"
                  >每日</el-checkbox>
                </div>
                <!-- <div style="margin: 15px 0;"></div> -->
                <div>
                  <el-checkbox-group
                    v-model="checkedCities"
                    @change="handleCheckedCitiesChangeData"
                  >
                    <el-checkbox v-for="city in weeks" :label="city" :key="city">{{city}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="itemFive">
            <el-form-item label="时间设置:">
              <el-time-picker
                is-range
                v-model="value1"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              ></el-time-picker>
              <span @click="addDomain">
                <img src="@/images/scenic/jia.png" alt />
              </span>
            </el-form-item>
          </div>
          <!-- 新增域名 -->
          <div class="addDomains">
            <el-form-item
              v-for="(domain, index) in dynamicValidateForm.domains"
              :key="domain.key"
              :prop="'domains.' + index + '.value'"
            >
              <el-time-picker
                is-range
                v-model="domain.value"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              ></el-time-picker>
              <span @click.prevent="removeDomain(domain)">
                <img src="@/images/scenic/jian.png" alt />
              </span>
            </el-form-item>
          </div>
          <!-- 新增域名 -->
          <div>
            <el-form-item label="上传图片:">
              <span class="xingB">*</span>
              <el-upload action="#" list-type="picture-card" :auto-upload="false">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleDownload(file)"
                    >
                      <i class="el-icon-download"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </el-form-item>
            <div>
              <el-form-item label="描述:">
                <span class="xingA">*</span>
                <el-input type="textarea" :autosize="{minRows:3,maxRows:5}" v-model="form.name"></el-input>
              </el-form-item>
            </div>
            <div class="itemThree">
              <el-form-item label="状态:">
                <span class="xingA">*</span>
                <el-select v-model="value" placeholder="状态">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="下单模式:">
                <span class="xingB">*</span>
                <el-select v-model="value" placeholder="下单模式">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="itemFour">
              <el-form-item label="关键词类型:">
                <el-radio v-model="radio" label="1">不通知</el-radio>
                <el-radio v-model="radio" label="2">通知</el-radio>
                <span>
                  <span>注:</span>
                  <span>选择通知,会由档口发送短信通知用户到相应档口取餐</span>
                </span>
              </el-form-item>
            </div>
            <el-form-item class="itemBtn">
              <el-button>重置</el-button>
              <el-button class="btnL">确认授权</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const weekOptions = [
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
  "星期日"
];
const cityOptions = ["爱上咖啡哈萨克好尬水开关", "北京", "广州", "深圳"];
export default {
  data() {
    // 穿梭框
    const generateData = _ => {
      const data = [];
      for (let i = 1; i <= 15; i++) {
        data.push({
          key: i,
          label: `备选项 ${i}`,
          disabled: i % 4 === 0
        });
      }
      return data;
    };
    return {
      // 每日
      checkAll: false,
      checkedCities: ["上海", "北京"],
      weeks: weekOptions,
      isIndeterminate: true,
      // 穿梭框
      data: generateData(),
      value: [1],
      value4: [1],
      renderFunc(h, option) {
        return (
          <span>
            {option.key} - {option.label}
          </span>
        );
      },
      gateAuthorVisible: false, // 档口授权
      addRestaurantVisible: false, // 添加餐厅
      checkAll: false,
      checkedCities: ["上海", "北京"],
      cities: cityOptions,
      isIndeterminate: true,
      titleType: "",
      form: {
        name: ""
      },
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      // 上传图片
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      radio: "",
      dynamicValidateForm: {
        domains: [
          // {
          //   value: ""
          // }
        ],
        email: ""
      }
    };
  },
  methods: {
    // 删除添加域名
    removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    addDomain() {
      this.dynamicValidateForm.domains.push({
        value: "",
        key: Date.now()
      });
    },
    // 全选
    handleCheckAllChangeData(val) {
      this.checkedCities = val ? weekOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChangeData(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.weeks.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.weeks.length;
    },
    // 上传图片
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    // 添加餐厅
    addRestaurant(row) {
      if (row) {
        this.titleType = "编辑餐厅";
      } else {
        this.titleType = "添加餐厅";
      }
      this.addRestaurantVisible = true;
    },
    // 添加餐厅X
    addRestaurantHandleClose() {
      this.addRestaurantVisible = false;
    },
    // 餐厅管理档口授权
    gateAuthor() {
      this.gateAuthorVisible = true;
    },
    // 餐厅管理档口授权X
    gateAuthorHandleClose() {
      this.gateAuthorVisible = false;
    },
    // 穿梭框
    handleChange(value, direction, movedKeys) {
      console.log(value, direction, movedKeys);
    },
    // 全部选择
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    }
  }
};
</script>

<style lang='less' scoped>
.addRestaurantForm {
  .itemFive {
    img {
      margin-left: 10px;
    }
  }
  .addDomains {
    img {
      margin-left: 10px;
    }
  }
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #e74c3c;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -78px;
    color: #e74c3c;
  }
  /deep/.el-form-item__label {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 20px;
    margin-left: -100px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  .itemFour {
    span {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #e74c3c;
      > span:nth-child(1) {
        margin-right: 10px;
      }
    }
  }
  .itemThree {
    display: flex;
    .el-select {
      width: 280px;
    }
  }
  .itemTwo {
    display: flex;
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #4ecb73;
      border-color: #4ecb73;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      color: #666666;
    }
  }
  .itemOne {
    .el-input {
      width: 400px;
    }
  }
}
.tranStfer {
  /deep/.el-transfer-panel {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    display: inline-block;
    vertical-align: middle;
    width: 367px;
    max-height: 100%;
    box-sizing: border-box;
    position: relative;
    height: 490px;
  }
  /deep/.el-transfer-panel__list.is-filterable {
    height: 490px;
    padding-top: 0;
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #4ecb73;
    border-color: #4ecb73;
  }
  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
}
.transfer-footer {
  margin-left: 20px;
  padding: 6px 5px;
}
.itemBtnS {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 20px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.contentQp {
  width: 100%;
  height: 490px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .qpLeft {
    width: 40%;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    /deep/.el-checkbox {
      width: 100%;
      margin-bottom: 15px;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #4ecb73;
      border-color: #4ecb73;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      color: #666666;
    }
  }
  .qpCenter {
    width: 15%;
    height: 450px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    .qpCenterBtn {
      > div {
        > div:nth-child(1) {
          width: 100%;
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          > div:nth-child(2) {
            background: #ffffff;
            width: 140px;
            height: 40px;
            border: 1px solid #246deb;
            border-radius: 4px;
            text-align: center;
            line-height: 40px;
            color: #409eff;
            margin: 20px 0;
            /deep/.el-checkbox__input .el-checkbox__inner,
            .el-checkbox__input.is-indeterminate .el-checkbox__inner {
              display: none;
              color: #409eff;
            }
            .allCheck {
              color: #246deb;
            }
          }
          button {
            width: 140px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #246deb;
            border-radius: 4px;
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #246deb;
            cursor: pointer;
          }
        }
        > div:nth-child(2) {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          button {
            width: 140px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #e74c3c;
            border-radius: 4px;
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #e74c3c;
            margin-bottom: 20px;
            cursor: pointer;
          }
        }
      }
    }
    /deep/.el-form-item {
      margin-bottom: 10px;
    }
    /deep/.el-form-item__label {
      text-align: right;
      vertical-align: middle;
      float: left;
      line-height: 30px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .qpRight {
    width: 40%;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    /deep/.el-checkbox {
      width: 100%;
      margin-bottom: 15px;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #4ecb73;
      border-color: #4ecb73;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      color: #666666;
    }
  }
}
</style>